import {
  getFindVenueOverviewVersionQueryKey,
  useUpdateVenueOverviewVersion,
} from '@api';
import { useInvalidateQuery, useNotification } from '@common';
import { AxiosError } from 'axios';
import { VenueFoodBeverageContactFormDataType } from '../useVenueFoodBeverageContactFormSchema';

const TRANS_PATH = 'NOTIFICATIONS.UPDATE_VENUE_FOOD_BEVERAGE_CONTACT';

type UseUpdateVenueFoodBeverageContactReturnType = {
  updateVenueFoodBeverageContact: (
    data: VenueFoodBeverageContactFormDataType
  ) => Promise<void>;
};

type UseUpdateVenueFoodBeverageContactPropsType = {
  venueId: string;
  overviewVersion: string;
  onClose: () => void;
};

export const useUpdateVenueFoodBeverageContact = ({
  venueId,
  overviewVersion,
  onClose,
}: UseUpdateVenueFoodBeverageContactPropsType): UseUpdateVenueFoodBeverageContactReturnType => {
  const { mutateAsync } = useUpdateVenueOverviewVersion();
  const { showSuccess, showError } = useNotification();

  const { invalidateQuery } = useInvalidateQuery(
    getFindVenueOverviewVersionQueryKey(venueId, overviewVersion)
  );

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH}.SUCCESS.TITLE`,
      message: `${TRANS_PATH}.SUCCESS.MESSAGE`,
    });
    invalidateQuery();
    onClose();
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH}.ERROR.TITLE`,
      message: `${TRANS_PATH}.ERROR.MESSAGE`,
      error,
    });
  };

  const updateVenueFoodBeverageContact = async (
    data: VenueFoodBeverageContactFormDataType
  ): Promise<void> => {
    await mutateAsync(
      {
        venueId,
        overviewVersion,
        data: {
          foodBeverageContact: {
            companyContact: data.contact,
            notes: data.notes,
          },
        },
      },
      {
        onSuccess,
        onError,
      }
    );
  };

  return { updateVenueFoodBeverageContact };
};
